export enum education {
  HIGH_SCHOOL = 'HIGH_SCHOOL',

  ASSOCIATE = 'ASSOCIATE',

  BACHELOR = 'BACHELOR',

  MASTER = 'MASTER',

  DOCTORAL = 'DOCTORAL',
}
